import type { EntityFile } from '@/api/entities/types';

export function getHeroFile(files: EntityFile[]): EntityFile | null {
  const filtered = files.filter((f) => f.function === 'hero-img');

  return filtered.length > 0 ? filtered[0] : null;
}
